/* ===============================================================
   Cloth and colour selector.

   No cart, so selecting is not adding. It updates the address bar,
   swings the gallery to the run of pictures shot in the chosen
   cloth, updates the price, and carries the choice into the
   booking and enquiry links so the appointment already knows which
   cloth was on screen.
   =============================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-variants]');
  if (!root) return;

  var dataEl = root.querySelector('[data-variant-data]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants.length) return;

  var buttons = [].slice.call(root.querySelectorAll('.vr__o'));
  var bookBase = root.getAttribute('data-book') || '';
  var askBase = root.getAttribute('data-ask') || '';

  function slug(s) {
    return String(s).toLowerCase().trim().replace(/\s+/g, '-');
  }

  /* Current selection, one entry per option position. */
  var chosen = [];
  buttons.forEach(function (b) {
    if (b.getAttribute('aria-checked') === 'true') {
      chosen[+b.dataset.optionIndex] = b.dataset.optionValue;
    }
  });

  function match() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (chosen[j] != null && v.options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function addParam(url, value) {
    if (!url) return url;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'cloth=' + encodeURIComponent(value);
  }

  /* ---------------------------------------------------------------
     The run of pictures follows the cloth.

     Every frame is in the page; the ones photographed in another
     colour are marked off. A frame tagged with no colour is shared
     across the colourways and always stays. An odd run closes on a
     centred single frame rather than a half-empty row. Returns true
     when a run was found, so the caller knows not to fall back to
     swapping one opening frame.
     --------------------------------------------------------------- */
  function filterGallery() {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return false;

    var figs = [].slice.call(gal.querySelectorAll('.gl__f'));
    if (!figs.length) return false;

    var known = {};
    figs.forEach(function (f) {
      var c = f.getAttribute('data-cloth');
      if (c) known[c] = true;
    });

    var want = null;
    for (var i = 0; i < chosen.length; i++) {
      if (chosen[i] == null) continue;
      var s = slug(chosen[i]);
      if (known[s]) { want = s; break; }
    }
    if (!want) return false;

    gal.setAttribute('data-cloth', want);

    var visible = [];
    figs.forEach(function (f) {
      var c = f.getAttribute('data-cloth');
      var off = !!c && c !== want;
      f.classList.toggle('is-off', off);
      f.classList.remove('is-wide');
      if (!off) visible.push(f);
    });

    if (visible.length) {
      /* The newly opening frames should not wait on the lazy queue. */
      visible.slice(0, 2).forEach(function (f) {
        var img = f.querySelector('img');
        if (img) { img.loading = 'eager'; img.decoding = 'sync'; }
      });
      if (visible.length % 2 === 1) {
        visible[visible.length - 1].classList.add('is-wide');
      }
    }
    return true;
  }

  function apply(v) {
    if (!v) return;

    /* The address bar, without adding a history entry per click. */
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}

    /* Where a garment has a run per cloth, swing the whole run.
       Where it has one picture per variant, swap the opening frame. */
    if (!filterGallery() && v.image) {
      var firstImg = document.querySelector('.gl__f:not(.is-off) .gl__img');
      if (firstImg && firstImg.getAttribute('src') !== v.image) {
        firstImg.setAttribute('src', v.image);
        firstImg.removeAttribute('srcset');
      }
    }

    /* Price, where variants differ. */
    if (v.price != null) {
      var money = document.querySelector('.pd-money b');
      if (money && v.price > 0 && window.Shopify && Shopify.formatMoney) {
        try { money.textContent = Shopify.formatMoney(v.price); } catch (e) {}
      }
    }

    /* The booking and enquiry links carry the choice. */
    var label = v.title && v.title !== 'Default Title' ? v.title : null;
    if (label) {
      document.querySelectorAll('.pd-ctas a.s-pill, .pd-sticky__book').forEach(function (a) {
        a.setAttribute('href', addParam(bookBase, label));
      });
      document.querySelectorAll('a.pd-ask, .pd-sticky__ask').forEach(function (a) {
        a.setAttribute('href', addParam(askBase, label));
      });
    }

    /* Readouts. */
    root.querySelectorAll('[data-option-readout]').forEach(function (el) {
      var i = +el.getAttribute('data-option-readout');
      if (chosen[i] != null) el.textContent = chosen[i];
    });
  }

  /* Mark combinations that do not exist, so nobody picks a dead end. */
  function refreshAvailability() {
    buttons.forEach(function (b) {
      var i = +b.dataset.optionIndex;
      var trial = chosen.slice();
      trial[i] = b.dataset.optionValue;
      var exists = variants.some(function (v) {
        for (var j = 0; j < trial.length; j++) {
          if (trial[j] != null && v.options[j] !== trial[j]) return false;
        }
        return true;
      });
      b.dataset.unavailable = exists ? 'false' : 'true';
    });
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      var i = +b.dataset.optionIndex;
      chosen[i] = b.dataset.optionValue;
      buttons.forEach(function (o) {
        if (+o.dataset.optionIndex === i) {
          o.setAttribute('aria-checked', o === b ? 'true' : 'false');
        }
      });
      refreshAvailability();
      apply(match());
    });
  });

  refreshAvailability();
  apply(match());
})();
